import { render } from "./NotificationsTool.vue?vue&type=template&id=52a8c128"
import script from "./NotificationsTool.vue?vue&type=script&lang=js"
export * from "./NotificationsTool.vue?vue&type=script&lang=js"

import "./NotificationsTool.vue?vue&type=style&index=0&id=52a8c128&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/tools/NotificationsTool.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52a8c128"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52a8c128', __exports__)) {
    api.reload('52a8c128', __exports__)
  }
  
  module.hot.accept("./NotificationsTool.vue?vue&type=template&id=52a8c128", () => {
    api.rerender('52a8c128', render)
  })

}


export default __exports__